export const titles = [
    'Software Engineer',
    'Project Manager',
    'Marketing Specialist',
    'Financial Analyst',
    'Human Resources Manager',
    'Data Scientist',
    'Sales Representative',
    'Product Manager',
    'Customer Success Manager',
    'Business Analyst',
    'UX/UI Designer',
    'Accountant',
    'Social Media Manager',
    'Operations Manager',
    'Software Developer',
    'Graphic Designer',
    'Quality Assurance Analyst',
    'Content Writer',
    'IT Consultant',
    'Customer Service Representative',
    'Legal Counsel',
    'Healthcare Administrator',
    'Public Relations Specialist',
    'Operations Coordinator',
    'Network Engineer',
    'Supply Chain Manager',
    'Executive Assistant',
    'Financial Advisor',
    'Content Marketing Manager',
    'Systems Analyst',
    'HR Coordinator',
    'Technical Writer',
    'Event Planner',
    'Digital Marketing Specialist',
    'Customer Support Specialist',
    'Software Architect',
    'Public Accountant',
    'Business Development Manager',
    'Web Developer',
    'Administrative Assistant',
    'Healthcare Consultant',
    'Sales Manager',
    'Research Scientist',
    'Training Coordinator',
    'Data Analyst',
    'Customer Relations Manager',
    'UI Designer',
    'Systems Administrator',
    'Account Executive',
    'Legal Assistant',
    'Content Strategist',
    'IT Manager',
    'Product Designer',
    'Business Intelligence Analyst',
    'Brand Manager',
    'Financial Planner',
    'Customer Service Manager',
    'Java Developer',
    'Social Media Coordinator',
    'Logistics Coordinator',
    'Technical Support Engineer',
    'Digital Strategist',
    'Accounting Manager',
    'Operations Analyst',
    'UX Researcher',
    'Sales Representative',
    'Full Stack Developer',
    'Marketing Coordinator',
    'Financial Analyst',
    'Talent Acquisition Specialist',
    'Software Tester',
    'Customer Service Representative',
    'Business Systems Analyst',
    'Supply Chain Analyst',
    'Executive Director',
    'HR Generalist',
    'Desktop Support Technician',
    'Marketing Analyst',
    'IT Specialist',
    'Content Manager',
    'Sales Associate',
    'Database Administrator',
    'Recruiter',
    'Public Relations Manager',
    'Financial Controller',
    'Project Coordinator',
    'Customer Success Specialist',
    'Technical Project Manager',
    'Content Developer',
    'Sales Coordinator',
    'UX Designer',
    'Network Administrator',
    'Product Marketing Manager',
    'Quality Assurance Engineer',
    'Financial Consultant',
    'Customer Service Coordinator',
    'IT Support Specialist',
    'Digital Content Specialist',
    'Accounting Clerk',
    'Research Analyst',
    'Technical Trainer',
    'Systems Engineer',
    'Content Marketing Coordinator',
    'Financial Analyst',
    'Customer Support Representative',
    'Data Engineer',
    'Sales Specialist',
    'Social Media Strategist',
    'Business Development Coordinator',
    'IT Analyst',
    'Project Analyst',
    'Operations Supervisor',
    'UX/UI Developer',
    'Accounting Analyst',
    'Public Relations Coordinator',
    'Healthcare Manager',
    'IT Consultant',
    'Customer Service Supervisor',
    'Legal Advisor',
    'Healthcare Analyst',
    'Marketing Communications Manager',
    'Operations Specialist',
    'Network Architect',
    'Supply Chain Coordinator',
    'Executive Secretary',
    'Financial Planner',
    'Content Marketing Specialist',
    'Systems Administrator',
    'HR Manager',
    'Technical Writer',
    'Event Coordinator',
    'Digital Marketing Coordinator',
    'Customer Support Specialist',
    'Software Architect',
    'Public Accountant',
    'Business Development Director',
    'Web Developer',
    'Administrative Coordinator',
    'Healthcare Consultant',
    'Sales Director',
    'Research Analyst',
    'Training Specialist',
    'Data Scientist',
    'Customer Relations Coordinator',
    'UI/UX Designer',
    'Systems Manager',
    'Account Executive',
    'Legal Secretary',
    'Content Strategist',
    'IT Manager',
    'Business Intelligence Analyst',
    'Brand Coordinator',
    'Financial Advisor',
    'Customer Service Manager',
    'Java Developer',
    'Social Media Specialist',
    'Logistics Specialist',
    'Technical Support Specialist',
    'Digital Strategist',
    'Accounting Manager',
    'Operations Analyst',
    'UX Researcher',
    'Sales Specialist',
    'Full Stack Developer',
    'Marketing Specialist',
    'Financial Analyst',
    'Talent Acquisition Coordinator',
    'Software Tester',
    'Customer Service Representative',
    'Business Systems Analyst',
    'Supply Chain Analyst',
    'Executive Manager',
    'HR Specialist',
    'Desktop Support Specialist',
    'Marketing Analyst',
    'IT Specialist',
    'Content Manager',
    'Sales Representative',
    'Database Administrator',
    'Recruitment Specialist',
    'Public Relations Director',
    'Financial Controller',
    'Project Specialist',
    'Customer Success Specialist',
    'Technical Project Coordinator',
    'Content Developer',
    'Sales Specialist',
    'Senior UX Designer',
    'Network Specialist',
    'Product Marketing Specialist',
    'Quality Assurance Engineer',
    'Financial Consultant',
    'Customer Service Coordinator',
    'IT Support Specialist',
    'Digital Content Specialist',
    'Accounting Specialist',
    'Research Specialist',
    'Technical Trainer',
    'Business Analyst',
    'Quality Assurance Specialist',
    'Operations Manager',
    'Cybersecurity Analyst',
    'Content Creation Specialist',
    'Financial Strategist',
    'Customer Experience Manager',
    'Data Architect',
    'Brand Strategist',
    'Business Operations Manager',
    'IT Security Specialist',
    'E-commerce Specialist',
    'Supply Chain Planner',
    'Senior Fullstack Developer',
    'Senior Fullstack Engineer',
    'Senior QA Engineer',
];

export const months = Array.from({ length: 12 }, (_, i) => i).map((month) => new Date(0, month));
export const years = Array.from({ length: 50 }, (_, i) => i).map(
    (year) => new Date(new Date().getFullYear() - year, 0)
);
